export default __webpack_public_path__ + "static/media/pkan_r_5512_bp.71e2db83.svg";